import React from "react";
import Button from "../button";
import BaseModal from "../modal/base/BaseModal";

type TournamentNoticeDialogProps = {
  close: () => void;
  onConfirm?: () => void;
  onClose?: () => void;
};

const TournamentNoticeDialog = ({
  close,
  onConfirm,
  onClose,
}: TournamentNoticeDialogProps) => {
  const handleClose = () => {
    onClose?.();
    close();
  };

  const handleConfirm = () => {
    onConfirm?.();
    close();
  };

  return (
    <BaseModal
      className="p-[20px] rounded-[15px] min-w-[311px]"
      size="dialog"
      close={handleClose}
      enableOutsideClick={false}
    >
      <section className="flex flex-col gap-y-[20px]">
        <div className="flex-1 space-y-[10px] flex flex-col items-center">
          {/* 이미지 */}
          <img src="/icons/ic-tournament.webp" className="w-8 h-auto" />
          {/* 제목 */}
          <h1 className="text-base font-semibold text-black break-keep whitespace-pre-wrap text-center">
            제1회 백마강 PGK 파크골프킹 대회
          </h1>
          {/* 콘텐츠 */}
          <p className="text-[#8e8e93] text-xs text-center break-keep whitespace-pre-wrap">
            상세 일정은 공지사항에서 확인해 주세요.
          </p>
        </div>
        <div className="flex-row-between gap-[10px] shrink-0">
          <Button
            className="w-full text-base px-[3px] py-[12px]"
            label="다시 보지 않기"
            variant={"white"}
            onClick={handleClose}
          />
          <Button
            className="w-full text-base px-[3px] py-[12px]"
            label="일정 확인"
            variant={"black"}
            onClick={handleConfirm}
          />
        </div>
      </section>
    </BaseModal>
  );
};

export default React.memo(TournamentNoticeDialog);
